<template>
  <ElConfigProvider :locale="locale">
    <router-view/>
  </ElConfigProvider>
</template>

<script>
import zhCn from "element-plus/es/locale/lang/zh-cn";

export default {
  name: 'App',
  data() {
    return {
      locale: zhCn
    }
  }
}
</script>

<style lang="less">
  .page-box{
    padding-top: 0px;
  }
</style>
